import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

const Wrapper = styled.div`
  overflow-x: auto;
`

const Row = styled.tr`
  ${props => props.header && css`
    color: ${Theme.colors.white};
    background: ${Theme.colors.dark_grey};
  `}
  ${props => props.nowrap && css`
    white-space: nowrap;
  `}
  ${props => props.zebra && css`
    :nth-child(odd) {
      background: ${Theme.colors.off_white};
    }
  `}
`

const Table = styled.table`
  width: 100%;
  margin-bottom: 100px;
  border-spacing: 0;
`

const Cell = styled.td`
  padding: 10px 20px;
  text-align: left;
  ${props => props.nowrap && css`
    white-space: nowrap;
  `}
`

const Header = styled.th.attrs(({
  scope
}) => ({
  scope: scope || null
}))`
  padding: 10px 20px;
  text-align: left;
  ${props => props.nowrap && css`
    white-space: nowrap;
  `}
  ${Media.desktop`
    font-weight: 600;
  `}
`

export default { Wrapper, Table, Row, Cell, Header }
